/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { IScheduledJob, EScheduledJobStatus } from '../../../core/models';

@Component({
  selector: 'fm-scheduler-balloon-section-item',
  templateUrl: './scheduler-balloon-section-item.component.html',
  styleUrls: ['./scheduler-balloon-section-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulerBalloonSectionItemComponent {
  @Input()
  public set scheduledJob(value: IScheduledJob) {
    this._scheduledJob = value;
    this._setAddressLength();
  }

  public get scheduledJob(): IScheduledJob {
    return this._scheduledJob;
  }

  @Output()
  public scheduledJobClicked = new EventEmitter<IScheduledJob>();

  public EScheduledJobStatus = EScheduledJobStatus;
  public croppedAddress: string;

  private _scheduledJob: IScheduledJob;

  public onClick(): void {
    this.scheduledJobClicked.emit(this.scheduledJob);
  }

  private _setAddressLength(): void {
    if (this.scheduledJob.address.length > 60) {
      this.croppedAddress = this.scheduledJob.address.substring(0, 60).replace(/\W*\s(\S)*$/, '...');
    }
  }
}
